import { useContext } from 'react'
import { MatiApiClientContext } from '@/providers'

export const useThreatProfilesApiClient = (ns) => {
  const { threatProfilesClient } = useContext(MatiApiClientContext)
  return ns ? threatProfilesClient?.[ns] : threatProfilesClient
}
